<template>
  <div class="card-form-section">
    <b-row>
      <b-col cols="12" class="mb-4">
        <p class="">
          <img src="@/assets/images/icons/icon-form.svg" alt="" />
          Por favor diligencia los siguientes datos:
        </p>
      </b-col>
      <b-col cols="12" class="mb-5">
        <Input
          label="Nombre del inspector"
          name="inspection_by"
          :value="formData.inspection_by"
          :required="true"
          :readonly="isBusy || isDetail"
          @input="(event) => (formData.inspection_by = event.target.value)"
        />
      </b-col>
      <b-col cols="12" class="mb-5">
        <Input
          label="Lista de herramientas utilizadas para la tarea"
          name="tool_list"
          :value="formData.tool_list"
          :required="true"
          :readonly="isBusy || isDetail"
          @input="(event) => (formData.tool_list = event.target.value)"
        />
      </b-col>
      <b-col cols="12" class="mb-5">
        <Input
          label="Lista de materiales utilizados para la tarea"
          name="material_list"
          :value="formData.material_list"
          :required="true"
          :readonly="isBusy || isDetail"
          @input="(event) => (formData.material_list = event.target.value)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import useInputs from "@/components/general/Inputs";
const { Input } = useInputs();
export default {
  props: {
    isBusy: {
      type: Boolean,
      default: false,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    answerResults: {
      type: Object,
      default: null,
    },
  },
  components: {
    Input,
  },
  data() {
    return {
      formData: {
        inspection_by: "",
        tool_list: "",
        material_list: "",
      },
    };
  },
  watch: {
    formData: {
      handler() {
        const me = this;
        me.$emit("changeFirstForm", me.formData);
      },
      deep: true,
    },
    answerResults: {
      handler() {
        const me = this;
        if (me.answerResults) me.formData = { ...me.formData, ...me.answerResults };
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss"></style>
